<template>
  <div>
    <div v-for="(offer, index) in sortedOffers" :key="'card-'+index" ref="cardOffers">
      <div class="pa-3 pb-4" style="border-bottom:1px solid #E8EAF2" v-if="(showDeleted ? true : !offer.isDeleted)">
          <div class="layout align-center mt-2 gap" v-if="offer.volunteering">
                  <div class="px-2">
                      <button class="f-size-20 text-primary fal" @click="offer.visible = !offer.visible" :class="offer.visible ? 'fa-minus-circle' : 'fa-plus-circle'"></button>
                    </div>
                  <div>
                      <div class="text-default f-size-11" v-text="offer.isRecurrent ? getDate(offer.weekDay.groups[0].date) : getDate(offer.updatedAt)"></div>
                      <div class="layout align-center gap-sm">
                          <h3>{{ offer.campaignName }}</h3> - 
                          <h4 class="text-red f-size-18" v-text="offer.volunteering.entity.name"></h4>
                      </div>
                      <div style="display: flex; margin-top: 10px">
                        <p style="text-align: center; color:white; background: #02ACB4; border-radius: 12px; padding-right: 10px; padding-left: 10px; width: 115px" v-if="!offer.isDeleted">Ativo</p>
                        <p style="text-align: center; color:white; background: red; border-radius: 12px; padding-right: 10px; padding-left: 10px; width: 115px" v-else>Cancelado</p>
                    </div>
                  </div>
          </div>
          <div class="info-box" :class="{ active: offer.visible}">
              
              <h3 class="f-size-18" v-text="offer.volunteeringInformation.fullName"></h3>

              <!-- CARD START -->
                <v-card class="p-2 mt-2" style="border: 1px solid #E8EAF2">
                  <v-card-title class="flex-column gap-sm align-stretch">
                      <div class="layout justify-space-between">
                          <h4 class="f-size-16 text--primary" v-text="offer.offerName"></h4>
                          <div class="d-flex">
                              <div class="layout gap">
                                  <template v-if="offer.isPresentialOportunityAllowed">
                                    <v-tooltip top>
                                        <template v-slot:activator="{on}">
                                        <div v-on="on">
                                          <Icon
                                            name="text-orange fal fa-users icon-attribute f-size-18"
                                            v-on="on"
                                          />
                                        </div>
                                        </template>
                                        <span>Atuação presencial</span>
                                    </v-tooltip>
                                  </template>
                                  <template v-if="offer.isDistanceOportunityAllowed">
                                    <v-tooltip top>
                                        <template v-slot:activator="{on}">
                                        <div v-on="on">
                                          <Icon
                                            name="text-orange fal fa-globe-americas icon-attribute f-size-18"
                                            v-on="on"
                                          />
                                        </div>
                                        </template>
                                        <span>Atuação à distância</span>
                                    </v-tooltip>
                                  </template>
                              </div>
                          </div>
                      </div>

                      <!-- IS RECURRENT -->
                      <template v-if="offer.isRecurrent">
                          <div class="layout justify-space-between text--primary f-w-bold">
                              <div class="caption">Data de início</div>
                             
                              <div class="caption">{{ getDate(offer.weekDay.groups[0].date) }}</div>
                          </div>
                          <v-divider></v-divider>
                          <div class="d-flex gap flex-direction-row row">
                              <v-sheet class="layout bg-orange br-sm align-center justify-center" style="max-width: 76px; width: 20%;">
                                  <i class="text-white fal fa-sync icon-attribute f-size-18"></i>
                              </v-sheet>
                              <div class="f-w-bold" style="width: 80%">
                                  <div class="text-orange f-size-16">{{ offer.isRecurrent ? getTotalHours(offer.weekDay) : ''}} horas semanais</div>
                                  <div class="text--primary f-size-20">{{ getDays(offer) }}</div>
                                  <div class="caption">{{ offer.isRecurrent ? getAllInitiatedHours(offer.weekDay) : '' }}</div>
                              </div>
                          </div>
                          <v-divider></v-divider>
                          <div class="layout justify-space-between text--primary f-w-bold">
                              <div class="caption">Data de término</div>
                              <div class="caption">{{ getDate(offer.volunteeringRecurrentTypesInfo.Recurrent[0].VolunteeringDateUntil) }}</div>
                          </div>
                      <v-divider></v-divider>
                      </template>
                      <!-- END OF RECURRENT -->

                      <!-- START PONTUAL -->
                      <div class="d-flex flex-column gap-xs" v-if="offer.isPontual">
                          <template>
                              <div v-for="(pontual, indexPontual) in offer.sortedPontual" :key="'consent'+indexPontual">
                                <div class="item-pill br-sm f-w-bold">
                                  <i class="fas fa-calendar icon-attribute text-orange"></i>
                                  <div class="grow text-orange" v-text="getDate(pontual.VolunteeringDate)"></div>
                                  <div>{{ pontual.ConvertedInitialTime }}h às {{ pontual.ConvertedFinalTime }}h</div>
                                </div>
                              </div>
                          </template>
                      </div>
                      
                      <!-- END PONTUAL -->
                      
                      <div class="layout gap-sm">
                          <i class="fal fa-map-marker-alt text-primary"></i>
                          <div class="f-size-12 text-dark" v-text="hasAddress(offer) ? offer.address.street + ' - ' + offer.address.number + ' - ' + offer.address.city + ' - ' + offer.address.postalCode : 'Endereço incompleto'"></div>
                        </div>
                  </v-card-title>
              </v-card>
              <!-- Prazo de cancelamento: informado sempre e, passado o prazo, o botão
                   fica desabilitado. A regra que vale é a do servidor, que valida a data
                   da própria inscrição -- aqui é para o voluntário saber de antemão. -->
              <div
                v-if="!offer.isDeleted && offer.isPontual && cancellationDeadlineText(offer)"
                class="f-size-12 mt-3"
                :class="isCancellationOpen(offer) ? 'text-dark' : 'text-orange'"
              >
                <template v-if="isCancellationOpen(offer)">
                  Cancelamento permitido até {{ cancellationDeadlineText(offer) }}.
                </template>
                <template v-else>
                  Prazo de cancelamento encerrado em {{ cancellationDeadlineText(offer) }}.
                </template>
              </div>
              <!-- Registro da atividade: só depois que ela termina, e só uma vez por
                   inscrição. Enviado, o botão vira o estado da moderação. -->
              <div v-if="userTestimonyFor(offer)" class="f-size-12 mt-3 text-dark">
                <template v-if="userTestimonyFor(offer).reviewedAt == null">
                  Registro enviado, em análise pela instituição.
                </template>
                <template v-else-if="userTestimonyFor(offer).isApproved">
                  Registro publicado na página do voluntariado. Obrigado!
                </template>
                <template v-else>
                  Registro enviado não foi aprovado pela instituição.
                </template>
              </div>
              <div class="layout gap-xs mt-3">
                  <v-btn class="orange text-orange ma-0" outline
                    v-if="!offer.isDeleted"
                    :disabled="!isCancellationOpen(offer)"
                    @click="$emit('cancelVolunteering', offer.registrationOfferId)"
                  >
                    Cancelar voluntariado
                  </v-btn>
                  <v-btn class="btn-primary ma-0" v-if="canSendUserTestimony(offer)" @click="openUserTestimony(offer)">
                    Enviar registro e depoimento
                  </v-btn>
                  <v-btn outline @click="consentTerm(true, offer)">Termos</v-btn>
                  <v-btn outline @click="preRequisitesTerm(true, offer.preRequisites)">Pré-requisitos</v-btn>
              </div>
          </div>
      </div>
    </div>
    <ConsentTerms
      :key="printTerms"
      v-model="printTerms"
      :info="offerContent"
      @close="printTerms = false"
      @accept="printTerms = false"
      :consentTerms="consentTermContent"
      :fromDash="true"
    />
    <PreRequisites
      :key="preRequisitesDialog"
      v-model="preRequisitesDialog"
      @close="preRequisitesDialog = false"
      :preRequisites="preRequisitesContent"
      :fromDash="true"
    />
    <ModalVolunteeringUserTestimony
      v-model="userTestimonyDialog"
      :offer="userTestimonyOffer"
      @close="userTestimonyDialog = false"
      @saved="$emit('userTestimonySaved')"
    />
  </div>
</template>

<script type="plain/text">
import moment from "moment";
import ConsentTerms from "@/components/ConsentTerms.vue";
import CampaignService from "@/scripts/services/campaign.service"
import VolunteeringAttributeOfferService from "@/scripts/services/volunteeringAttributeOffer.service";
import VolunteeringRegistrationOfferService from "@/scripts/services/volunteeringRegistrationOffer.service";
import VolunteeringService from "@/scripts/services/volunteering.service"
import PreRequisites from "@/components/PreRequisites.vue";
import ModalVolunteeringUserTestimony from "@/components/volunteering/ModalVolunteeringUserTestimony.vue";

export default {
  components: {
    ConsentTerms,
    PreRequisites,
    ModalVolunteeringUserTestimony
  },
  props: {
    attributeOffer: Object,
    showDeleted: Boolean,
    // Registros que o voluntário já enviou, para o card mostrar o estado em vez do
    // botão. Vem de fora porque é uma chamada por usuário, não por inscrição.
    userTestimonies: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sortedOffers() {
    return this.dynamicList.map((offer) => {
        if (offer.isPontual && offer.volunteeringPontualTypesInfo.Pontual) {
            offer.sortedPontual = [...offer.volunteeringPontualTypesInfo.Pontual].sort(
                (a, b) => a.VolunteeringDate.localeCompare(b.VolunteeringDate)
            );
        }
        return offer;
    });
  },
  },
  watch: {
    // async attributeOffer() {
    //   await this.infoHandler()
    // },
  },
  data: () => ({
    dynamicList: [],
    printTerms: false,
    volunteeringService: new VolunteeringService(),
    volunteeringAttributeOfferService: new VolunteeringAttributeOfferService(),
    volunteeringRegistrationOfferService: new VolunteeringRegistrationOfferService(),
    campaignService: new CampaignService(),
    preRequisitesContent: null,
    preRequisitesDialog: false,
    consentTermContent: null,
    offerContent: null,
    offers: [],
    userTestimonyDialog: false,
    userTestimonyOffer: null,
  }),
  async created() {
    await this.getWeekDays(this.attributeOffer)
    await this.infoHandler()
  },
  methods: {
    getDate(date) {

      const dateValue = new Date(date)
      return  dateValue.getDate().toString().padStart(2,'0') + '/' + (dateValue.getMonth() + 1).toString().padStart(2,'0') + '/' + dateValue.getFullYear()
    },
    getPontualStart(pontual) {
      // ConvertedInitialTime chega como "HH:mm"; trato data completa também, porque
      // outros endpoints devolvem o horário nesse formato.
      const time = /^\d{2}:\d{2}$/.test(pontual.ConvertedInitialTime)
        ? pontual.ConvertedInitialTime
        : moment(pontual.ConvertedInitialTime).format('HH:mm');
      const date = moment(pontual.VolunteeringDate).format('YYYY-MM-DD');
      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    },
    nextPontualStart(offer) {
      const info = offer.volunteeringPontualTypesInfo;
      const items = (info && info.Pontual) || [];
      const starts = items
        .map(pontual => this.getPontualStart(pontual))
        .sort((a, b) => a.valueOf() - b.valueOf());
      return starts.length ? starts[0] : null;
    },
    cancellationDeadline(offer) {
      // Usa a data MAIS PRÓXIMA do grupo: é a primeira a vencer, então é o prazo que
      // realmente limita o voluntário.
      const hours = Number(offer.minimumCancellationNoticeHours);
      const start = this.nextPontualStart(offer);
      if (!hours || hours <= 0 || !start) return null;
      return start.clone().subtract(hours, 'hours');
    },
    cancellationDeadlineText(offer) {
      const deadline = this.cancellationDeadline(offer);
      return deadline ? deadline.format('DD/MM/YYYY [às] HH:mm') : null;
    },
    isCancellationOpen(offer) {
      // Vaga recorrente não tem data única de realização, então fica fora da regra.
      if (!offer.isPontual) return true;
      const deadline = this.cancellationDeadline(offer);
      if (!deadline) return true;
      return moment().isBefore(deadline);
    },
    getPontualEnd(pontual) {
      const time = /^\d{2}:\d{2}$/.test(pontual.ConvertedFinalTime)
        ? pontual.ConvertedFinalTime
        : moment(pontual.ConvertedFinalTime).format('HH:mm');
      const date = moment(pontual.VolunteeringDate).format('YYYY-MM-DD');
      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    },
    lastPontualEnd(offer) {
      // A ÚLTIMA data do grupo: enquanto houver data futura, a atividade não terminou.
      const info = offer.volunteeringPontualTypesInfo;
      const items = (info && info.Pontual) || [];
      const ends = items
        .map(pontual => this.getPontualEnd(pontual))
        .sort((a, b) => b.valueOf() - a.valueOf());
      return ends.length ? ends[0] : null;
    },
    userTestimonyFor(offer) {
      return this.userTestimonies.find(
        item => item.volunteeringRegistrationOfferId === offer.registrationOfferId
      );
    },
    canSendUserTestimony(offer) {
      // Inscrição cancelada não gera registro, e cada inscrição envia uma vez.
      if (offer.isDeleted || this.userTestimonyFor(offer)) return false;
      // Pontual só depois que a última data escolhida termina. Recorrente é um
      // compromisso contínuo: pode registrar a qualquer momento.
      if (!offer.isPontual) return true;
      const end = this.lastPontualEnd(offer);
      return end ? moment().isAfter(end) : false;
    },
    openUserTestimony(offer) {
      this.userTestimonyOffer = offer;
      this.userTestimonyDialog = true;
    },
    async getWeekDays() {
      for (const attribute of this.attributeOffer) {
        if (attribute.isRecurrent) {
          const res = await this.volunteeringRegistrationOfferService.findUserRegistrationRecurrencyGoogleCalendar(attribute.id)
          attribute.weekDay = res
          this.offers.push(attribute)
        } else {
          this.offers.push(attribute)
        }
      }
    },
    getTotalHours(weekDay) {
      let totalMinutes = 0;

      weekDay.groups.forEach(group => {
        const [startHour, startMinute] = group.initialHour.split(':').map(Number);
        const [endHour, endMinute] = group.finalHour.split(':').map(Number);

        const start = startHour * 60 + startMinute;
        const end = endHour * 60 + endMinute;

        totalMinutes += (end - start) * (group.weekDayNames.length);
        
      });

      const hours = Math.floor(totalMinutes / 60);
      return `${hours}`;
    },
    getDayOfWeekAbbreviation(dateString) {
      const dayString = dateString.charAt(0).toUpperCase() + dateString.slice(1, 3);
      return dayString;
    },
    getAllInitiatedHours(weekDay) {
      const scheduleByDay = {}

      for (const item of weekDay.groups) {
        for (const day of item.weekDayNames) {
          const dayAbbrev = this.getDayOfWeekAbbreviation(day)
            if (!scheduleByDay[dayAbbrev]) {
              scheduleByDay[dayAbbrev] = []
            }

            if (!scheduleByDay[dayAbbrev].includes(item.initialHour + '-' + item.finalHour)) {
              scheduleByDay[dayAbbrev].push(item.initialHour + ' até ' + item.finalHour)
            }
          }
        }

      const result = Object.entries(scheduleByDay).map(([day, hours]) => {
        return `${day} - ${hours.join(', ')}`
      })

    return result.join(', ')
    },
    getDays(items) {
      const days = []

      for (const item of items.weekDay.groups) {
        for (const day of item.weekDayNames) {
          const dayAbrevv = this.getDayOfWeekAbbreviation(day)
          if (!days.includes(dayAbrevv)) {
            days.push(dayAbrevv)
          }
        }
      }
      return days.join(', ')
    },
    async infoHandler() {
      if (this.offers) {
        for (const offer of this.offers) {
          if (offer.isPontual && this.isJsonString(offer.volunteeringPontualTypesInfo)) {
            offer.volunteeringPontualTypesInfo = await JSON.parse(offer.volunteeringPontualTypesInfo)
          }
          else if (offer.isRecurrent && this.isJsonString(offer.volunteeringRecurrentTypesInfo)) {
            offer.volunteeringRecurrentTypesInfo = await JSON.parse(offer.volunteeringRecurrentTypesInfo)
          }

          if (offer.isRecurrent) {
            offer.campaignId = offer.volunteeringRecurrentTypesInfo.Recurrent[0].CampaignId  
            offer.campaignName = offer.volunteeringRecurrentTypesInfo.Recurrent[0].CampaignName
          }

          else if (offer.isPontual) {
            offer.campaignId = offer.volunteeringPontualTypesInfo.Pontual[0].CampaignId  
            offer.campaignName = offer.volunteeringPontualTypesInfo.Pontual[0].CampaignName
          }
        }

        this.offers.forEach(element => {
          this.dynamicList.push({...element, visible: false});
        });

        
      }
    },
    consentTerm(open, offer) {
      this.printTerms = open;
      this.consentTermContent = offer.consentTerm
      this.offerContent = offer
    },
    preRequisitesTerm(open, requisites) {
      this.preRequisitesDialog = open;
      this.preRequisitesContent = requisites
    },
    hasAddress(offer) {
      return offer.address.street && offer.address.number && offer.address.city && offer.address.postalCode
    },
    isJsonString(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
    },
  },
};
</script>